import { render, staticRenderFns } from "./BatchForms.vue?vue&type=template&id=414c7c8a&scoped=true&"
import script from "./BatchForms.vue?vue&type=script&lang=js&"
export * from "./BatchForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c7c8a",
  null
  
)

export default component.exports